module.exports = {
  isLocal: process.env.NODE_ENV === 'development',
  isDevelopment: process.env.NEXT_PUBLIC_HOSTING_ENV === 'sand',
  isProduction: process.env.NEXT_PUBLIC_HOSTING_ENV === 'prod',
};
